/**
 * Provides style for the input range picker component
 */
import { ViewStyle, Platform } from 'react-native';
import styled from 'styled-components/native';

import { Colors } from 'theme/colors';
import { FontFamily, FontSize } from 'theme/fonts';
import { color, ColorProps } from 'styled-system';

const BUTTON_HEIGHT = Platform.select({ default: 40, web: 50 });
const BUTTON_MARGIN = Platform.select({ default: 5, web: 10 });
const BUTTON_RADIUS = Platform.select({ default: 20, web: 25 });

export const Title = styled.Text`
  font-size: ${FontSize.Regular};
  font-family: ${FontFamily.Bold};
  color: ${Colors.black};
`;

export const Content = styled.View<ViewStyle>`
  width: ${({ width }) => width || 'auto'};
  background-color: ${Colors.gallery};
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-left: ${BUTTON_MARGIN}px;
  padding-right: ${BUTTON_MARGIN}px;
  border-radius: ${BUTTON_RADIUS}px;
  height: ${BUTTON_HEIGHT}px;
`;

export const Button = styled.TouchableOpacity<ColorProps>`
  width: 30px;
  height: 30px;
  border-radius: 15px;
  justify-content: center;
  align-items: center;
  background-color: ${Colors.green};
  ${color}
`;

export const Counter = styled.View`
  flex-grow: 1;
  justify-content: center;
  align-items: center;
`;

export const Message = styled.Text`
  font-size: ${FontSize.Regular};
  font-family: ${FontFamily.Light};
  color: ${Colors.suvaGray};
  text-align: center;
  margin-left: 10px;
  margin-right: 10px;
`;
